
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskActionType } from 'enums/TaskActionType';
import { Model, ModelProperty } from 'models/Model';


export class QueryTaskActionModel extends Model<QueryTaskActionModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'taskActionId', type: 'string' },
		{ name: 'completed', type: 'Date' },
		{ name: 'plannedDate', type: 'Date' },
		{ name: 'taskActionCreated', type: 'Date' },
		{ name: 'assignedToUserId', type: 'string' },
		{ name: 'taskflowId', type: 'string' },
		{ name: 'taskflowCurrentStep', type: 'number' },
		{ name: 'taskflowTitle', type: 'string' },
		{ name: 'companyId', type: 'string' },
		{ name: 'companyName', type: 'string' },
		{ name: 'type', type: 'TaskActionType' }
	];
	[key: string]: any;
	
	public taskActionId?: string;
	public completed?: Date;
	public plannedDate?: Date;
	public taskActionCreated?: Date;
	public assignedToUserId?: string;
	public taskflowId?: string;
	public taskflowCurrentStep: number;
	public taskflowTitle: string;
	public companyId?: string;
	public companyName: string;
	public type: TaskActionType;
    
	constructor(){
		super();
		this.taskActionId = undefined;
		this.completed = undefined;
		this.plannedDate = undefined;
		this.taskActionCreated = undefined;
		this.assignedToUserId = undefined;
		this.taskflowId = undefined;
		this.taskflowCurrentStep = 0;
		this.taskflowTitle = '';
		this.companyId = undefined;
		this.companyName = '';
		this.type = 0;
		
	}
	getProperties(){
		return QueryTaskActionModel.classProperties;
	}
}

